import React, { useCallback, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FilterBar from '../../../components/filter-bar';
import { FilterViewProps } from '../../../store/shipments/filtering/filterview.properties';
import * as Actions from '../../../store/shipments/filtering/shipments.filtering.actions';
import { requestGetShipments } from '../../../store/shipments/shipments.actions';
import { FiltersContext } from '../../../filters/context';
import { mapOrdersFilterBarFiltersToContext } from '../../../filters/context/map-filter-bar-filters-to-context';
import { useShipmentsFilterBarState } from './hooks';

import style from './style.module.less';

export const filterBar = 'filterBar';

const ShippingFilterBarContainer = () => {
  const dispatch = useDispatch();
  const { replaceFiltersForSource } = useContext(FiltersContext);
  const {
    allFilterBys,
    appliedFilters,
    criteriaArgumentsMap,
    criteriaOperatorsMap,
    currentFilterView,
    implicitFilterByIds,
    otherFilterBys,
    popularFilterBys,
    filterViewId,
  } = useShipmentsFilterBarState();

  const onFiltersChanged = useCallback(
    (newFilters) => {
      if (newFilters.length === 0) {
        replaceFiltersForSource(filterBar);
        return dispatch(Actions.autoSwitchFilterViewToDefault());
      }

      const newContextFilters = mapOrdersFilterBarFiltersToContext(newFilters, filterBar, true);
      replaceFiltersForSource(filterBar, newContextFilters);

      if (currentFilterView.filterViewId === 'custom') {
        dispatch(Actions.changeCustomFilterViewProp(FilterViewProps.FILTERVIEW_FILTERS, newFilters));
        dispatch(requestGetShipments());
        return;
      }
      dispatch(Actions.autoSwitchFilterViewToCustom(newFilters, currentFilterView));
      dispatch(requestGetShipments());
    },
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, currentFilterView],
  );

  const clearFilters = useCallback(() => {
    const lockedFilters = appliedFilters.filter((filter) => filter.isLocked);
    onFiltersChanged(lockedFilters);
  }, [onFiltersChanged, appliedFilters]);

  useEffect(() => {
    const newContextFilters = mapOrdersFilterBarFiltersToContext(appliedFilters);
    replaceFiltersForSource(filterBar, newContextFilters);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [filterViewId]);

  return (
    <div className={style['filter-bar-wrapper']}>
      <FilterBar
        allFilterBys={allFilterBys}
        appliedFilters={appliedFilters}
        clearFilters={clearFilters}
        criteriaArgumentsMap={criteriaArgumentsMap}
        criteriaOperatorsMap={criteriaOperatorsMap}
        currentFilterView={currentFilterView}
        implicitFilterByIds={implicitFilterByIds}
        onFiltersChanged={onFiltersChanged}
        otherFilterBys={otherFilterBys}
        popularFilterBys={popularFilterBys}
      />
    </div>
  );
};

export default ShippingFilterBarContainer;
